/**
 * @title myorders_helper.js: Feature level module
 * @description Utility module associated with my account
 */
define([], function() {
	var MyOrdersHelper = {
			
	/**
	 * Make the ajax call
	 * 
	 */
	ajax_update_state: function(options, page) {
      if (!options.done) options.done = COSTCO.MyOrdersHelper.ajax_update_default_done
      COSTCO.util.ajax(options);
    },
    
    /**
	 * Success call back handler
	 * 
	 */
	ajax_update_default_done: function(data, textStatus, jqXHR, options) {
	      try {
	        var response_obj = typeof(data) === 'object' ? data : JSON.parse(data);
	        var defaultOptions = {
	          ajax_append_content: COSTCO.MyOrdersHelper.ajax_append_content,
	          ajax_handle_errors: COSTCO.MyOrdersHelper.ajax_handle_errors,
	          ajax_update_post_done: function() {},
	          error_container: '',
	          scrollToError: true
	        }
	        $('body').trigger('costco.ajax.content.update.start', response_obj);
	        var mergedOptions = $.extend(true, {}, defaultOptions, options);
	        // Inject New Html
	        mergedOptions.ajax_append_content(response_obj, mergedOptions, defaultOptions);
	        // Post Html Injection
	        mergedOptions.ajax_update_post_done(response_obj, mergedOptions, defaultOptions);
	        
	        // Handle any Errors and perform cleanup
	        mergedOptions.ajax_handle_errors(response_obj, mergedOptions, defaultOptions);
	        $('body').trigger('costco.ajax.content.update.end', response_obj);
	      } catch (e) {
	        console.error(e);
	      }
	    },
	    
	    /**
		 * Append content to the end of already existing div html
		 * 
		 */
	    ajax_append_content: function(response_obj, mergedOptions, defaultOptions) {
	        Object.keys(response_obj.payload.html).forEach(function(key) {
	          var encoded_html = response_obj.payload.html[key];
	          if (mergedOptions.replaceKey) {
	            if (mergedOptions.replaceKey.original == key) {
	              key = mergedOptions.replaceKey.replace;
	            }
	          }
	          $('#' + key).append(COSTCO.util.get_decoded_html(encoded_html));
	        });
	      },
	      
	      /**
	  	 * Display errors
	  	 * 
	  	 */
	      ajax_handle_errors: function(response_obj, mergedOptions, defaultOptions) {
	      	$('.error').empty(); //clear any errors that may be on the page
	        var error_container = mergedOptions.error_container;
	        var application = response_obj.error.application || [];
	        var exception = response_obj.error.exception || [];
	        var error_html = "";
	        if (typeof(error_container) === 'string') {
	          error_container = $(error_container);
	        }
	        if (error_container == '' || error_container.length == 0) {
	          $('body').trigger('costco.ajax.content.update.sucess', response_obj);
	          return;
	        }
	        error_container.children().remove();
	        if (exception.length > 0) {
	          error_html += '<p>An unexpected error has occured</p>';
	        }
	        application.forEach(function(error_message) {
	          error_html += '<p>' + error_message.replace(/''/g, "'") + '</p>';
	        });
	        //if there is a redirect, store the error in sessionStorage and redirect user,
	        //otherwise error will show in error container
	        if (response_obj.error.redirect) {
	        	if(typeof sessionStorage != 'undefined') {
	        		sessionStorage.setItem('errorMessage', error_html); //store error_html in sessionStorage to show on redirected page
	        	}
	        	document.location.href = '/' + response_obj.error.redirect;
	        	return;
	        }
	        error_container.append(error_html);
	        if (mergedOptions.scrollToError && COSTCO.util.has_errors(response_obj)) {
	          $('body').trigger('costco.ajax.content.update.error', response_obj);
	          $('html, body').scrollTo(error_container, 100);
	        }
	      }
	}  
  if (typeof window.COSTCO === "undefined") {
    window.COSTCO = new Object();
  }
  window.COSTCO.MyOrdersHelper = MyOrdersHelper;
  return MyOrdersHelper;
});


// WEBPACK FOOTER //
// ./js/account/myorders_helper.js